import { useEffect, useState } from "react";
import config from "../config";
import { TOKEN_KEY } from "../constants";

function useGetDataRightsRequests() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataRightsRequests, setDataRightsRequests] = useState([]);

  const fetchDataRightsRequests = async() => {
    const token = sessionStorage.getItem(TOKEN_KEY)

    try {
      setLoading(true);

      const url = config.requestTable

      const response = await fetch(url, {
        method: "GET",
        withCredentials: true,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status !== 200) {
        throw new Error("Unsuccessful request")
      }

      const list = await response.json();

      setDataRightsRequests(list);
    }
    catch (error) {
      setError("Could not fetch Data Rights requests");
      throw new Error(error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataRightsRequests();
  }, []);

  return { loading, error, dataRightsRequests };
}

export default useGetDataRightsRequests;
